import React, { useState, useEffect, useRef } from 'react';

import Select from 'react-select';
import { faPlus, faMinus, faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import apiClient from '../utils/apiClient';
import { SERVER_BASE } from '../config/server';
import Swal from 'sweetalert2';
import { useNavigate, useLocation } from 'react-router-dom';

const statusOptions = [
  { value: 'As Stock', label: 'As Stock' },
  { value: 'Installed/Fitted with Structure', label: 'Installed/Fitted with Structure' },
  { value: 'Installed/Fitted with Machinery', label: 'Installed/Fitted with Machinery' },
  { value: 'Installed/Fitted with Construction', label: 'Installed/Fitted with Construction' },
  { value: 'Installed/Fitted underground', label: 'Installed/Fitted underground' },
  { value: 'Installed/Fitted above roof', label: 'Installed/Fitted above roof' },
  { value: 'Installed/Fitted under shed', label: 'Installed/Fitted under shed' },
  { value: 'Installed/Fitted above shed', label: 'Installed/Fitted above shed' },
  { value: 'Dormant Stock', label: 'Dormant Stock' },
  { value: 'Office Inventory', label: 'Office Inventory' },
  { value: 'As Condemnation Stock', label: 'As Condemnation Stock' },
];

const yesNoOptions = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
  { label: 'Not Applicable', value: 'Not Applicable' },
];

const OpeningStockLedger = ({ accessOfDepartments, accessedLedgers }) => {
  const code = localStorage.getItem('code');
  const name = localStorage.getItem('name');
  const badgeId = localStorage.getItem('badgeId');
  const email = localStorage.getItem('email'); // Retrieve email from localStorage
  const role = localStorage.getItem('role'); // Retrieve email from localStorage
  const token = localStorage.getItem('token');
  const [profileDetails, setProfileDetails] = useState(null); // State for profile details
  const [itemOptions, setItemOptions] = useState([]); // State for item options
  const [ledgerOptions, setLedgerOptions] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [selectedLedger, setSelectedLedger] = useState(null);
  const [editId, setEditId] = useState(null);
  const [locations, setLocations] = useState([]); // Location data
  const [consolidatedRemarks, setConsolidatedRemarks] = useState(""); // Location data
  const [rows, setRows] = useState([
    {
      item: null,
      location: null,
      status: null,
      quantity: '',
      value: '',
      acquisitionDate: '',
      approvedByDera: null,
      approvalNumber: '',
      approvalDate: '',
      standardPattern: null,
      requested: null,
      requestedDate: '',
      remarks: '',
    },
  ]);
  const [loadingData, setLoading] = useState(false);
  const navigate = useNavigate()
  const location = useLocation()
  const rowData = location?.state?.rowData;
  const previousLedgerRef = React.useRef(null);
  useEffect(() => {
    if (selectedLedger && !previousLedgerRef.current) {
      previousLedgerRef.current = selectedLedger;
    }
  }, [selectedLedger]);
  
  useEffect(() => {
    if (rowData) {
      handleEdit(rowData);
    }
  }, [rowData]);
  useEffect(() => {
    if (accessOfDepartments) {
      const deptArray = accessOfDepartments
        .split(',')
        .map((dept) => ({ value: dept.trim(), label: dept.trim() }));
      setDepartments(deptArray);
    }
  }, [accessOfDepartments]);
  const handleEdit = (rowData) => {

    setEditId(rowData.id);
    setConsolidatedRemarks(rowData?.consolidatedRemarks || '');
    setSelectedLedger({ label: rowData?.ledgerName, value: rowData?.ledgerName, ledgerId:rowData?.ledgerId });
    const formatDate = (isoDate) => {
      if (!isoDate) return '';

      const date = new Date(isoDate);
      // Add 5 hours and 30 minutes
      date.setHours(date.getHours() + 5);
      date.setMinutes(date.getMinutes() + 30);

      // Format to YYYY-MM-DD
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months start from 0
      const dd = String(date.getDate()).padStart(2, '0');

      return `${yyyy}-${mm}-${dd}`;
    };

    const mappedRows = (rowData.items || []).map(item => ({
      item: item.itemId ? {
        value: item?.printName,
        label: item?.printName,
        itemId: item?.itemId,
        itemCode: item?.itemCode,
        uom: item?.uom,
        unit: item?.unit,
        type: item?.type || '',
      } : null,
      status: item.status ? { label: item.status, value: item.status } : null,
      quantity: item.quantity || '',
      value: item.value || '',
      size: item?.size || '',
      acquisitionDate: item.acquisitionDate ? formatDate(item.acquisitionDate) : '',
      approvedByDera: item.approvedByDera ? { label: item.approvedByDera, value: item.approvedByDera } : null,
      approvalNumber: item.approvalNumber || '',
      approvalDate: item.approvalDate || '',
      standardPattern: item.standardPattern ? { label: item.standardPattern, value: item.standardPattern } : null,
      requested: item.requested ? { label: item.requested, value: item.requested } : null,
      requestedDate: item.requestedDate ? formatDate(item.requestedDate) : '',
      remarks: item.remarks || '',
    }));

    setRows(mappedRows.length ? mappedRows : [{
      item: null,
      location: null,
      status: null,
      quantity: '',
      value: '',
      size : '',
      acquisitionDate: '',
      approvedByDera: null,
      approvalNumber: '',
      approvalDate: '',
      standardPattern: null,
      requested: null,
      requestedDate: '',
      remarks: '',
    }]);
  };

  const fetchItemOptions = async (accessOfDepartmentsArray) => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/get-items-approved`, {
        params: {
          centerCode:code,
          // accessOfDepartments: accessOfDepartmentsArray
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setItemOptions(response.data.map((item) => ({
        value: item.printName,
        label: `${item.printName}${item.additionalNames ? ` - [ ${item.additionalNames} ]` : ''}`,
        itemId: item.id,
        itemCode: item.itemCode,
        uom: item.uom,
        unit: item.unit,
        type: item.type
      })));
    } catch (error) {
      console.error('Error fetching item options:', error.message);
      console.error('Details:', error.response?.data || error.message);
    }
  };
  const fetchledgermasterdetails = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + '/ledgerMastersMainTain', {
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });

      // Convert accessedLedgers (string like "45,54,58,89") into an array of numbers
      const accessedLedgerIds = accessedLedgers
        .split(',')
        .map((id) => parseInt(id.trim()));

      // Filter ledgers that are in accessedLedgers
      const filteredLedgers = response.data.filter((ledger) =>
        accessedLedgerIds.includes(ledger.id)
      );

      // Prepare options for dropdown
      const options = filteredLedgers.map((ledger) => ({
        value: ledger.printName,
        label: ledger.printName,
        ledgerId: ledger.id,
        group: ledger.ledgerGroup,
        address: ledger.address,
        gstin: ledger.gstin,
      }));

      setLedgerOptions(options);
    } catch (error) {
      console.error('Error fetching ledger master details:', error);
    }
  };
  useEffect(() => {

    const fetchProfileDetails = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email, role } });
        setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
      } catch (err) {
        console.error('Error fetching profile details:', err);
        setProfileDetails(null);
      }
    };
    const fetchLocations = () => {
      apiClient
        .get(SERVER_BASE + "/getLocations", {
          params: { code }, headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          }
        })
        .then((response) =>
          setLocations(
            response.data.map((location) => ({
              value: location.location,
              label: location.location,
            }))
          )
        )
        .catch((error) => console.error(error));
    };
    fetchProfileDetails();
    fetchLocations();
    fetchledgermasterdetails();
    fetchItemOptions(accessOfDepartments)
  }, [code, email]);

  const checkItemAlreadyExists = async (ledgerId, itemId) => {
    try {
      const res = await apiClient.post(
        `${SERVER_BASE}/checkOpeningStockItem`,
        { ledgerId, itemId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      return {
        exists: res.data?.exists || false,
        openingStockNos: res.data?.openingStockNos || []
      };
    } catch (err) {
      console.error(err);
      return {
        exists: false,
        openingStockNos: []
      };
    }
  };
  
  
  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const addRow = () => {
    setRows([
      ...rows,
      {
        item: null,
        location: null,
        status: null,
        quantity: '',
        value: '',
        acquisitionDate: '',
        approvedByDera: null,
        approvalNumber: '',
        approvalDate: '',
        standardPattern: null,
        requested: null,
        requestedDate: '',
        remarks: '',
      },
    ]);
  };

  const removeRow = (index) => {
    if (rows.length > 1) {
      const updatedRows = [...rows];
      updatedRows.splice(index, 1);
      setRows(updatedRows);
    }
  };
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
  });

  const handleSubmit = async () => {
    setLoading(true)
    if (!selectedLedger) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        title: 'Please select ledger',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
      });
      setLoading(false)
      return;
    }
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      const rowIndex = i + 1;

      if (!row.item?.value) {
        setLoading(false)
        return Toast.fire({ icon: 'warning', title: `Item is required in row ${rowIndex}` });
      }
      //   if (!row.location?.value) {
      //     setLoading(false)
      //     return Toast.fire({ icon: 'warning', title: `Location is required in row ${rowIndex}` });
      //   }
      if (!row.status?.value) {
        setLoading(false)
        return Toast.fire({ icon: 'warning', title: `Status is required in row ${rowIndex}` });
      }
      if (!row.quantity || isNaN(row.quantity) || parseFloat(row.quantity) <= 0) {
        setLoading(false)
        return Toast.fire({ icon: 'warning', title: `Valid Quantity is required in row ${rowIndex}` });
      }
      // if (!row.acquisitionDate) {
      //   setLoading(false)
      //   return Toast.fire({ icon: 'warning', title: `Acquisition Date is required in row ${rowIndex}` });
      // }
      if (!row.approvedByDera?.value) {
        setLoading(false)
        return Toast.fire({ icon: 'warning', title: `Approved By Dera is required in row ${rowIndex}` });
      }

      if (row.approvedByDera.value === 'yes') {
        if (!row.approvalNumber) {
          setLoading(false)
          return Toast.fire({ icon: 'warning', title: `Approval Number is required in row ${rowIndex}` });
        }
        if (!row.approvalDate) {
          setLoading(false)
          return Toast.fire({ icon: 'warning', title: `Approval Date is required in row ${rowIndex}` });
        }
        if (!row.standardPattern?.value) {
          setLoading(false)
          return Toast.fire({ icon: 'warning', title: `Standard Pattern is required in row ${rowIndex}` });
        }
      }

      if (row.approvedByDera.value === 'no') {
        if (!row.requested?.value) {
          setLoading(false)
          return Toast.fire({ icon: 'warning', title: `Requested field is required in row ${rowIndex}` });
        }
        if (row.requested.value === 'yes' && !row.requestedDate) {
          setLoading(false)
          return Toast.fire({ icon: 'warning', title: `Requested Date is required in row ${rowIndex}` });
        }
        if (row.requested.value === 'no' && !row.remarks) {
          setLoading(false)
          return Toast.fire({ icon: 'warning', title: `Remarks are required in row ${rowIndex}` });
        }
      }
    }

    const formattedData = rows.map((row) => ({
      itemId: row.item?.itemId,
      printName: row.item?.value || '',
      itemCode: row.item?.itemCode || '',
      uom: row.item?.uom || '',
      type:row?.item?.type || '',
      size:row?.size || '',
      status: row.status?.value || '',
      quantity: row.quantity,
      value: row.value,
      acquisitionDate: row.acquisitionDate,
      approvedByDera: row.approvedByDera?.value || '',
      approvalNumber: row.approvedByDera?.value === 'yes' ? row.approvalNumber : '',
      approvalDate: row.approvedByDera?.value === 'yes' ? row.approvalDate : '',
      standardPattern: row.approvedByDera?.value === 'yes' ? row.standardPattern?.value || '' : '',
      requested: row.approvedByDera?.value === 'no' ? row.requested?.value || '' : '',
      requestedDate:
        row.approvedByDera?.value === 'no' && row.requested?.value === 'yes'
          ? row.requestedDate
          : '',
      remarks:
        row.approvedByDera?.value === 'no' && row.requested?.value === 'no'
          ? row.remarks
          : '',
    }));

    const formData = {
      id: editId,
      createdBy: name,
      createdByBadge: badgeId,
      centerCode: code,
      ledgerId: selectedLedger?.ledgerId || '',
      ledgerName: selectedLedger?.label,
      date: '2025-04-01',
      stockEntries: formattedData,
      consolidatedRemarks
    };

    try {
      if (editId) {
        // Update route
        await apiClient.post(`${SERVER_BASE}/updateOpeningStockLedger`, formData);
        Toast.fire({ icon: 'success', title: 'Opening stock updated successfully!' });
      } else {
        // Save route
        await apiClient.post(`${SERVER_BASE}/saveOpeningStockLedger`, formData);
        Toast.fire({ icon: 'success', title: 'Opening stock saved successfully!' });
      }
      navigate('../OpeningStockLedgerList')
      // Reset form
    } catch (err) {
      console.error(err);
      setLoading(false)
      Toast.fire({ icon: 'error', title: 'Failed to save opening stock' });
    }
  };

  return (
    <div className="formcontainer mt-5">
      <div className="d-flex align-items-end mb-3">
        <button
          className="btn btn-secondary btn-sm me-3"
          onClick={() => navigate('../OpeningStockLedgerList')}
        >
          <FontAwesomeIcon icon={faChevronCircleLeft} /> Back
        </button>
        <h5 className="mb-0">Ledger Opening Stock</h5>
      </div>
      <div className="row align-items-end mb-3">
        <div className="col-md-3">
          <label className="form-label">Date</label>
          <input
            type="text"
            className="form-control"
            value="1 April 2025"
            readOnly
          />
        </div>
        <div className="col-md-6">
          <label className="form-label">Ledger</label>
          <Select
  options={ledgerOptions}
  value={selectedLedger}
  onChange={async (selectedOption) => {
    const hasItemsSelected = rows.some(
      (row) => row.item && row.item.itemId
    );

    // If ledger already selected AND items exist AND ledger is changing
    if (
      selectedLedger &&
      selectedLedger.ledgerId !== selectedOption.ledgerId &&
      hasItemsSelected
    ) {
      const result = await Swal.fire({
        icon: 'warning',
        title: 'Change Ledger?',
        html: `You have already added item(s) for the selected ledger, If you change the ledger, all selected items will be removed. Do you still want to continue?`,
        showCancelButton: true,
        confirmButtonText: 'Yes, change ledger',
        cancelButtonText: 'No',
        allowOutsideClick: false
      });

      if (!result.isConfirmed) {
        // ⛔ Revert ledger selection
        setSelectedLedger(previousLedgerRef.current);
        return;
      }

      // ✅ User confirmed → clear rows
      setRows([{
        item: null,
        location: null,
        status: null,
        quantity: '',
        value: '',
        acquisitionDate: '',
        approvedByDera: null,
        approvalNumber: '',
        approvalDate: '',
        standardPattern: null,
        requested: null,
        requestedDate: '',
        remarks: '',
      }]);
    }

    // ✅ Apply ledger change
    setSelectedLedger(selectedOption);
    previousLedgerRef.current = selectedOption;
  }}
/>

        </div>

        <div className="col-md-3">
          <label className="form-label">Remarks</label>
          <input
            type="text"
            className="form-control"
            value={consolidatedRemarks}
            onChange={(e) => setConsolidatedRemarks(e.target.value)}
          />
        </div>
      </div>
      {rows.map((row, index) => (
        <div key={index} className="border rounded p-3 mb-3 bg-light">
          {/* First line: Item, Location, Status, Quantity, Value */}
          <div className="row mb-2">
            <div className="col-md-1">
              <label>S.No</label>
              <input
                type="number"
                min="0"
                className="form-control"
                value={index + 1}
                onChange={(e) => handleChange(index, 'quantity', e.target.value)}
                readOnly
              />
            </div>

            <div className="col-md-4">
              <label>Item</label>
              <Select
  options={itemOptions}
  value={row.item}
  onChange={async (value) => {
    if (!selectedLedger?.ledgerId || !value?.itemId) {
      handleChange(index, 'item', value);
      return;
    }
    const { exists, openingStockNos } =
    await checkItemAlreadyExists(
      selectedLedger.ledgerId,
      value.itemId
    );
  
    if (exists) {
      const voucherList = openingStockNos.join(", ");
    
      const result = await Swal.fire({
        icon: 'warning',
        title: 'Item already exists',
        html: `
            This item <strong>"${value.label}"</strong> has already been added as opening stock
            in voucher(s): ${voucherList}. Do you still wish to continue adding additional quantities for this ledger?
        `,
        showCancelButton: true,
        confirmButtonText: 'Yes, add again',
        cancelButtonText: 'No',
        allowOutsideClick: false
      });
    
      if (!result.isConfirmed) return;
    }
    
    

    handleChange(index, 'item', value); // ✅ allow
  }}
/>

            </div>
            {(row.item?.type === "Constructed Structure" || row.size) && (
              <div className="col-md-2">
                <label>Size</label>
                <input
                  type="text"
                  className="form-control"
                  value={row.size || ""}
                  onChange={(e) => handleChange(index, 'size', e.target.value)}
                />
              </div>
            )}
            {/* <div className="col-md-2">
              <label>Location</label>
              <Select
                options={locations}
                value={row.location}
                onChange={(value) => handleChange(index, 'location', value)}
              />
            </div> */}
            <div className="col-md-3">
              <label>Status</label>
              <Select
                options={statusOptions}
                value={row.status}
                onChange={(value) => handleChange(index, 'status', value)}
              />
            </div>
            <div className="col-md-1">
              <label>Quantity</label>
              <input
                type="number"
                min="0"
                className="form-control"
                value={row.quantity}
                onChange={(e) => handleChange(index, 'quantity', e.target.value)}
              />
            </div>
            <div className="col-md-1">
              <label>UOM</label>
              <input
                type="text"
                className="form-control"
                value={row?.item?.uom}
                readOnly
              />
            </div>
            <div className="col-md-2" style={{ width: "10%" }}>
              <label>Value</label>
              <input
                type="number"
                min="0"
                className="form-control"
                value={row.value}
                onChange={(e) => handleChange(index, 'value', e.target.value)}
              />
            </div>

            <div className="col-md-2">
              <label>Acquisition Date</label>
              <input
                type="date"
                className="form-control"
                value={row.acquisitionDate}
                onChange={(e) => handleChange(index, 'acquisitionDate', e.target.value)}
              />
            </div>
            <div className="col-md-2">
              <label>Qty. Approved By Dera</label>
              <Select
                options={yesNoOptions}
                value={row.approvedByDera}
                onChange={(value) => handleChange(index, 'approvedByDera', value)}
              />
            </div>

            {row.approvedByDera?.value === 'Yes' && (
              <>
                <div className="col-md-2">
                  <label>Approval No.</label>
                  <input
                    type="text"
                    className="form-control"
                    value={row.approvalNumber}
                    onChange={(e) => handleChange(index, 'approvalNumber', e.target.value)}
                  />
                </div>
                <div className="col-md-2">
                  <label>Approval Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={row.approvalDate}
                    onChange={(e) => handleChange(index, 'approvalDate', e.target.value)}
                  />
                </div>
                <div className="col-md-2">
                  <label>Standard Pattern</label>
                  <Select
                    options={yesNoOptions}
                    value={row.standardPattern}
                    onChange={(value) => handleChange(index, 'standardPattern', value)}
                  />
                </div>
              </>
            )}

            {row.approvedByDera?.value === 'No' && (
              <>
                <div className="col-md-2">
                  <label>Is Request Generated</label>
                  <Select
                    options={yesNoOptions}
                    value={row.requested}
                    onChange={(value) => handleChange(index, 'requested', value)}
                  />
                </div>

                {row.requested?.value === 'Yes' && (
                  <div className="col-md-2">
                    <label>Requested Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={row.requestedDate}
                      onChange={(e) => handleChange(index, 'requestedDate', e.target.value)}
                    />
                  </div>
                )}

                {row.requested?.value === 'No' && (
                  <div className="col-md-3">
                    <label>Not Requested Reason</label>
                    <input
                      type="text"
                      className="form-control"
                      value={row.remarks}
                      onChange={(e) => handleChange(index, 'remarks', e.target.value)}
                    />
                  </div>
                )}
              </>
            )}
            <div className="col-md-1 d-flex align-items-end">
              <button
                type="button"
                className="btn btn-success btn-sm me-2"
                onClick={addRow}
              >
                <FontAwesomeIcon icon={faPlus} />
              </button>
              <button
                type="button"
                className="btn btn-danger btn-sm"
                onClick={() => removeRow(index)}
              >
                <FontAwesomeIcon icon={faMinus} />
              </button>
            </div>
          </div>
        </div>
      ))}
      <div className="text-end mt-4">
        <button className="btn btn-success" onClick={handleSubmit} disabled={loadingData}>
          {loadingData ? "Submitting" : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default OpeningStockLedger;
